export enum FilterOperator {
    EQUALS = 'eq',
    /** Used for matching all provided values in an array, i.e. multiple tags */
    EQUALS_ALL = 'eqAll',
    GREATER_THAN_OR_EQUAL = 'gteq',
    LESSER_THAN_OR_EQUAL = 'lteq',
    CONTAINS = 'contains',
}

export type FilterId = string
export type FilterValue = string | number | Date | undefined | null

export type Filter = {
    id?: FilterId
    key: string
    operator: FilterOperator
    value: FilterValue
    nonClearable?: boolean
}

export type UpdateFilterValueParams = {
    filter: Filter
    newValue: FilterValue
}

export type UpdateFilterValueModel = (params: UpdateFilterValueParams) => void

export type FilterProviderModel = {
    isInitialized: boolean
    filters: Filter[]
    hasFiltersWithValue: boolean
    hasClearableFilters: boolean
    updateFilterValue: UpdateFilterValueModel
    isExpanded: boolean
    /** @deprecated use getFilterId exported directly from the filter-provider */
    getFilterId: (key: string, operator: FilterOperator) => FilterId
    getFilterValue: (id: FilterId) => FilterValue | undefined
    hasFilterForKey: (key: string) => boolean
    toggleFilters: () => void
    clearFilters: () => void
    registerFilter: (filter: Filter) => void
    getFilterById: (key: FilterId) => Filter | undefined
}

export type FiltersPOSTBodyType = {
    filters: [
        {
            name: string
            operator: FilterOperator
            value: FilterValue
        },
    ]
}

export interface FilterParams {
    filters?: Filter[]
}